import { useForm } from 'react-hook-form';
import { IntegratedFormProvider } from '../forms/integrated-form-provider';
import { useMutation } from '@tanstack/react-query';
import { FormTextarea } from '../forms/integrated-form-controls/form-text-area';
import { useCallback } from 'react';
import { useApiClient } from '@m43/core';
import { ButtonGroup, ModalBody, ModalFooter, ModalHeader } from '@cad-arc';
import { FormCancelButton } from '../forms/integrated-form-components/form-cancel-button';
import { FormSaveButton } from '../forms/integrated-form-components/form-save-button';
import { ReactivateEventResource } from '@mark43/cad-api';

const requiredRule = { required: 'Required' };
export function ReactivateClearedEventModal(props: { eventId: number; onClose: () => void }) {
    const apiClient = useApiClient();
    const reactivateClearedEventMutation = useMutation(
        (args: { eventId: number; reason: string }) => {
            return apiClient.request<ReactivateEventResource.CadNextReactivateEvent>({
                method: 'POST',
                url: 'reactivate_event/',
                data: {
                    reason: args.reason,
                    eventId: args.eventId,
                },
            });
        },
        {
            onSuccess() {
                props.onClose();
            },
        }
    );
    const reactivateClearedEventForm = useForm<{ reason: string }>({
        defaultValues: {
            reason: '',
        },
    });
    const onSubmit = useCallback(
        (formValues: { reason: string }) => {
            reactivateClearedEventMutation.mutate({
                ...formValues,
                eventId: props.eventId,
            });
        },
        [props.eventId, reactivateClearedEventMutation]
    );
    return (
        <IntegratedFormProvider
            form={reactivateClearedEventForm}
            onSubmit={onSubmit}
            mutation={reactivateClearedEventMutation}
        >
            <>
                <ModalHeader>Reactivate Event</ModalHeader>
                <ModalBody>
                    <FormTextarea
                        label="Reason"
                        name="reason"
                        rules={requiredRule}
                        control={reactivateClearedEventForm.control}
                        autoFocus
                    />
                </ModalBody>
                <ModalFooter>
                    <ButtonGroup>
                        <FormCancelButton size="xl" variant="ghost" onClick={props.onClose}>
                            Cancel
                        </FormCancelButton>
                        <FormSaveButton size="xl" variant="solid">Reactivate</FormSaveButton>
                    </ButtonGroup>
                </ModalFooter>
            </>
        </IntegratedFormProvider>
    );
}
